export const workflowstore = {
  db: {
    users: [],
    user: {},
    token: "",
    project_list: [],
  },
};